import Button from "../../Atoms/Button/Button";
import "./CardCostCampaing.scss";

const CardCostCampaing = ({cost, balance}) => {
  return (
    <div className="box-price">
      <div className="box-price_cols1">
        <p className="source-16 sm-bold">
          Costo diario de tu campaña hasta el momento:
        </p>
        <div className="box-price_resume">
          <p className="source-24 bold mb-10">USD ${cost}</p>
          <p className="source-16 link">Ver resumen</p>
        </div>
      </div>
      <div className="box-price_cols2">
        <p className="source-16 sm-bold">Tu saldo en tu wallet</p>
        <p className="source-16 c-blue sm-bold">USD ${balance}</p>
        <Button
          content="Recargar"
          type="primary"
          customClass="s-large m-auto"
        />
      </div>
    </div>
  );
};

export default CardCostCampaing;
